import Image from '@/src/components/CustomImage'
import React, { useMemo } from 'react'
import styles from './index.module.scss'

// 导入图片资源

interface Section3Props {
  isChina: boolean
  message: {
    __doesWork: string
    __canProcess: string
    __deployment: string
    __step1: string
    __step2: string
    __step3: string
  }
}

const Section3: React.FC<Section3Props> = ({ message, isChina }) => {
  const pictures = useMemo(() => {
    return Array(3)
      .fill(0)
      .map((_, index) => ({
        imgSrc: `/assets/images/api/Part3_${index + 1}_${isChina ? 'zh' : 'en'}.png`,
        description: message[`__step${index + 1}`]
      }))
  }, [isChina, message])

  return (
    <section className={styles.section3}>
      <Image src="/assets/images/api/Part3_bg.png" fill alt="api bg" />
      <div className={styles.container}>
        <div className={styles.boxLeft}>
          <h2>{message.__doesWork}</h2>
          <p>{message.__canProcess}</p>
        </div>
        <div className={styles.boxRight}>
          <h3>{message.__deployment}</h3>
          <ul className={styles.flexImgBox}>
            {pictures.map((elm, idx) => (
              <React.Fragment key={idx}>
                <li className={styles.imgBox}>
                  <Image
                    width={380}
                    height={364}
                    data-yqrole="img"
                    src={elm.imgSrc}
                    className={styles.imgResponsive}
                    alt={elm.description}
                  />

                  <p className={styles.imgDescription}>{elm.description}</p>
                </li>
                {idx < 2 && (
                  <div className={styles.arrow}>
                    <span>&gt;&gt;</span>
                  </div>
                )}
              </React.Fragment>
            ))}
          </ul>
        </div>
      </div>
    </section>
  )
}

export default Section3
